import React from 'react';
import { useTranslation } from 'react-i18next';
import './MobileFooter.css';
import { EmojiText } from './common/Picto';

interface MobileFooterProps {
  onNavigateToPrivacy?: () => void;
  onNavigateToTerms?: () => void;
}

const MobileFooter: React.FC<MobileFooterProps> = ({ onNavigateToPrivacy, onNavigateToTerms }) => {
  const { t } = useTranslation();
  const handlePrivacy = () => {
    if (onNavigateToPrivacy) onNavigateToPrivacy();
    else window.location.href = '/privacy';
  };

  const handleTerms = () => {
    if (onNavigateToTerms) onNavigateToTerms();
    else window.location.href = '/terms';
  };

  return (
    <footer className="app-mobile-footer">
      <div className="app-mobile-footer__links">
        <button className="app-mobile-footer__link" onClick={handlePrivacy}>
          <EmojiText text={t('appFooter.privacy') as string} />
        </button>
        <div className="app-mobile-footer__sep" />
        <button className="app-mobile-footer__link" onClick={handleTerms}>
          <EmojiText text={t('appFooter.terms') as string} />
        </button>
        <div className="app-mobile-footer__sep" />
        <a className="app-mobile-footer__link" href="mailto:jogolinga@gmail.com">
          <EmojiText text={t('appFooter.contact') as string} />
        </a>
      </div>
      <p className="app-mobile-footer__copy">© {new Date().getFullYear()} JogoLinga</p>
    </footer>
  );
};

export default MobileFooter;
